<template>
	<div class="address_bigs">
		<address_box @bindselect='bindselect'></address_box>	
		<div style="width:1260px;margin:0 auto;padding-bottom:30px;">
			<div class="address_bottom" v-if="cart_list.length>0">
				<div class="lists">
					<div class="list_top">
						<div style="width:100px;" >
							<Checkbox v-model="single" @on-change='bindall' v-if='user.festival && user.festival.type == 2&&user.festival&&user.festival.id!=$store.state.hidePriceid'>全选</Checkbox>
							
						</div>
						<span style="width:500px;font-size:16px;">礼包</span>
						<span class="rights" style="font-size:16px;" v-if='user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid'>单价</span>
						<!-- <span class="rights" style="font-size:16px;">数量</span> -->
						<span class="rights" style="font-size:16px;" v-if='user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid'>小计</span>
						<span class="rights" style="font-size:16px;">操作</span>
					</div>
					<div class="list_bottom">
						<!-- <div v-for="items in orderdetail.orderItems" :key="items.id"> -->
							<div class="l_box" v-for="(item,index) in cart_list" :key="index">
								<div style="width:50px;" @click="binddx(item.show,index)"><Checkbox v-model="item.show" :disabled="item.kc_text!=''||(all_num==4&&user.festival&&user.festival.id==$store.state.hidePriceid&&!item.show)"></Checkbox></div>
								
								<div style="display: flex;align-items: center;width:550px;">
									<div>
											<div style='margin-bottom:10px;' v-if='user.festival && user.festival.type == 2'>
												<div style="display:flex;align-items:center;" v-if='item.yf_price'>
													<!-- <span class='by_bx'>包邮</span> -->
													<span>{{item.yf_price&&item.yf_price!='包邮'?item.yf_price:''}}</span>
												</div>
											</div>
											<div style="display:flex;align-items:center;">
												<img @click="binddetail(item.festivalPackage.uid)" style="height:80px;width:80px;margin-right:16px" :src="item.festivalPackage.imageUrl"/>
												<div>
													<div  @click="binddetail(item.festivalPackage.uid)">
														{{item.festivalPackage.name}}
													</div>
													<span v-if='item.kc_text' style="color:#fd5430;margin-top:6px;">{{item.kc_text}}库存不足</span>
													
												</div>
											</div>
											
									</div>
									
									
									
								</div>
								<div style='width: 200px;text-align: center;display:flex;align-items:center;justify-content: space-around;' v-if='user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid'>
									<div style="display:flex;align-items:center;">
										<img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
              							<img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
										{{item.festivalPackage.standardPrice/100}}
										<span style="font-size:16px;color:#FD5430;font-weight:600;margin-left:4px" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
									</div>
									
								</div>
								<!-- <div style='width: 200px;text-align: center;display:flex;align-items:center;justify-content: space-around;'>
									<div style="width: 82px;height: 24px;border-radius: 2px;border: 1px solid #CCCCCC;">
										<span class="jjj" @click="bindsub(index)">-</span>
										<span class="jjj" style="height:100%;border-left:1px solid #CCCCCC;border-right:1px solid #CCCCCC">{{item.num}}</span>
										<span class="jjj" @click="bindadd(index)">+</span>
									</div>
									
									
								</div> -->
								
								<div style='width: 200px;text-align: center;display:flex;align-items:center;justify-content: space-around;' v-if='user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid'>
									<div style="display:flex;align-items:center;">
										<img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
              							<img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
										{{item.festivalPackage.standardPrice/100}}
										<span style="font-size:16px;color:#FD5430;font-weight:600;margin-left:4px" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
									</div>
								</div>
								
								<div style='width: 200px;text-align: center;cursor: pointer;' @click="binddelate(index)">删除</div>
								
							</div>
						<!-- </div> -->
					</div>
					<div style="text-align:right;color:red" v-if='!show_address'>请选择地址</div>
					
					<div class="list_bottoms" style="height:60px;margin-top:30px;">
						<div style="width:100px;" >
							<Checkbox v-model="single" @on-change='bindall' v-if='user.festival && user.festival.type == 2&&user.festival&&user.festival.id!=$store.state.hidePriceid'>全选</Checkbox>
						</div>
						<div style="display:flex;align-items:center;">
							<div v-if='user.festival && user.festival.type == 2'>
								<div style="display:flex;align-items:center;color:#0A1132" v-if='user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid'>
									总计：
									<img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
              						<img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
									<span style="font-size:20px;color:#FD5430">{{all_price}}</span>
									<span style="font-size:16px;color:#FD5430;font-weight:600;margin-left:4px" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
								</div>
								<div style="text-align:right;color:red;font-size:12px;" v-if='user.festival&&user.festival.id==$store.state.hidePriceid&&all_num!=4'>请选择4个礼包进行兑换</div>
								<div v-if='user.festival.id!=$store.state.hidePriceid' style="font-size:12px">已选择<span style="color:#FB3F45;font-size:12px;margin:0 4px">{{all_num}}</span>件商品</div>
								<div v-else style="font-size:12px">已选择<span style="color:#FB3F45;font-size:12px;margin:0 4px">{{all_num}}</span>件商品<span v-if='all_num<4'>，剩余</span><span v-if='all_num<4' style="color:#FB3F45;font-size:12px;margin:0 4px">{{4-all_num}}</span><span v-if='all_num<4'>件</span></div>
							</div>
							<div v-if='user.festival&&user.festival.id==$store.state.hidePriceid'>
								<div v-if="all_num==4&&show_address" @click="bindjs" style="cursor: pointer;width:180px;height:60px;background:#F3A251;color:white;text-align:center;line-height:60px;margin-left:30px;">立即结算</div>
								<div v-else style="width:180px;height:60px;background:#F3A251;color:white;text-align:center;line-height:60px;margin-left:30px;opacity: 0.5;">立即结算</div>
							</div>
							<div v-else>
								<div v-if="all_num>0&&show_address" @click="bindjs" style="cursor: pointer;width:180px;height:60px;background:#F3A251;color:white;text-align:center;line-height:60px;margin-left:30px;">立即结算</div>
								<div v-else style="width:180px;height:60px;background:#F3A251;color:white;text-align:center;line-height:60px;margin-left:30px;opacity: 0.5;">立即结算</div>
							</div>
							
						</div>
					</div>
					<div style="text-align:right;color:#5B5D66;margin-top:12px;" v-if='user.festival && user.festival.type == 2&&user.festival.id!=$store.state.hidePriceid'>
						<span style="color:red">*最终售价以结算页面为准</span> </div>
				</div>
			</div>
			<div v-else style="width:246px;margin:165px auto;text-align:center;">
				<img style="width:100%" src="../../assets/img/no_lb.png" />
				<p style="color:#0A113;font-size:16px;">您的购物车是空的~</p>
			</div>
		</div>
	</div>
</template>

<script>
	import nav from '../nav';
	import getCurrentCityName from '../../js/map'
	import links from '../../js/link_parameters';
	import wechatAuth from '../../wechatAuth'
	import { Message, Loading } from 'element-ui';
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
	import Vue from 'vue'
	import $ from 'jquery'
	import axios from 'axios';
	import Tables from '../../components/tables/tables'
	import address_box from '../../components/address_box'
	import useCodeGenerate from '../../components/useCodeGenerate'
	import echarts from 'echarts'
	import {formatDate,formatTimeToStr} from '../../js/data'
	// import JsBarcode from 'jsbarcode'
	export default {
		name: 'index',
		components: {
			Tables,
			useCodeGenerate,
			address_box
		},
		data() {
			var vm = this
			return {
				
				user:'',
				cart_list:[],
				single:false,
				all_num:0,
				show_address:'',
				all_price:0
			}
		},
		computed: {},
		created() {},
		mounted() {
			
			var user = sessionStorage.getItem("user")
			
			if(user){
				this.user = JSON.parse(user)
			}else{
				this.$router.push({path:'/login'})
			}
			this.bindcart()
			if(!this.$store.state.balance){
				this.getUser()
			}
			console.log(axios.defaults.baseURL)
		},
		methods: {
			getUser(){
				var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
				this.$server.getCardUserBalance({},headers).then(res => {
					console.log('',res)
					if(res.code==0){
						var user = this.user
						this.$store.state.cardDate = res.data.default.cardDate;
						this.$store.state.validTimes=res.data.default.validTimes
         				this.$store.state.balance = res.data.default.balance;
						sessionStorage.setItem("user",JSON.stringify(user))
					}
				})
			},
			bindselect(e){
				console.log('选择后的地址',e)
				this.show_address = e
				this.qr_address1()
			},
			binddelate(index){
				var that = this
				 this.$confirm("是否删除礼包?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					that.cart_list.splice(index, 1)
					this.bindshow()
					localStorage.setItem("cart_list",JSON.stringify(that.cart_list));
					this.qr_address1()
				})
			},
			bindjs(){
				this.$router.push({path:'/address',query:{cart_show:true}})
				localStorage.setItem("show_address",JSON.stringify(this.show_address));
			},
			binddx(show,index){//点击单选
				if(this.user.festival && this.user.festival.type == 2){
					if(this.all_num==4&&this.user.festival.id==this.$store.state.hidePriceid&&!show){
						return
					}
					this.cart_list[index].show=!this.cart_list[index].show
					
				}else{
					this.cart_list.forEach((item1,index1)=>{
						if(index1!=index){
							// this.cart_list[index1].show=false
							this.$set(this.cart_list[index1],'show',false)
						}
					})
					this.$set(this.cart_list[index],'show',!this.cart_list[index].show)
					// this.cart_list[index].show=!this.cart_list[index].show
				}
				this.bindshow()
			},
			bindall(e){//点击全选
				console.log(e)
				var list = this.cart_list
				list.forEach((item)=>{
					if(!item.kc_text){
						item.show=e
					}
					
				})
				this.bindshow()
			},
			bindshow(e){//是否全选了
				var num =0
				var list = this.cart_list
				var all_price = 0
				list.forEach((item)=>{
					if(item.show){
						num+=1
						all_price+=item.festivalPackage.standardPrice
					}
				})
				if(num==list.length){
					this.single=true
				}else{
					this.single=false
				}
				this.all_num = num
				this.all_price = all_price/100
				localStorage.setItem("cart_list",JSON.stringify(this.cart_list));
			},
			bindcart(){
				var cart_list = localStorage.getItem("cart_list");
				var cart_lists = cart_list?JSON.parse(cart_list):[]
				cart_lists.forEach((item)=>{
					item.kc_text=''
				})
				this.cart_list =cart_lists
				console.log(this.cart_list )
				this.bindshow()
			},
			bindsub(index){
				if(this.cart_list[index].num>1){
					this.cart_list[index].num--
					localStorage.setItem("cart_list",JSON.stringify(this.cart_list));
				}
				
			},
			binddetail(e){
				this.$router.push({ path: "/detail", query: { id: e } });
			},
			bindadd(index){
				// var num = this.cart_list[index].num+1
				// console.log(num)
				// this.$set(this.cart_list[index],this.cart_list[index].num,num)
				// console.log(this.cart_list)
				this.cart_list[index].num++
				localStorage.setItem("cart_list",JSON.stringify(this.cart_list));
			},
			qr_address1(){
				var list = this.cart_list
				list.forEach((item,index)=>{
					var kc_text = this.qr_address(item,index)
					
				})
				console.log(this.cart_list)
			},
			qr_address(item,index) {
				var address = this.show_address
				var list = this.cart_list
				var spuIds=''
				var skuPurchaseNos=''
				// console.log(list)
				// list.forEach(item => {
				// 	console.log(item)
					item.spuList.forEach((item1)=>{
						spuIds+=item1.show_skuid+','
					})
					item.spuNoList.forEach((item2)=>{
						skuPurchaseNos+=item2+','
					})
				// })
				spuIds = spuIds.substring(0, spuIds.length - 1)
				skuPurchaseNos = skuPurchaseNos.substring(0, skuPurchaseNos.length - 1)
				var data = {
					skuIds: spuIds,
					skuPurchaseNos: skuPurchaseNos,
					districtId: address.districtId ? address.districtId : '0',
					townId: address.townId ? address.townId : '0',
					cityId: address.cityId ? address.cityId : '0',
					provinceId: address.provinceId ? address.provinceId : '0',
					addressDetail: address.detail ? address.detail : address.street ? address.street : ''
				};
				var headers = {
					"Content-Type": "application/x-www-form-urlencoded",
					Authorization: this.user.token
				};
				this.$server.verifyItemStock(data, headers).then(res => {
					console.log('查询库存',res)
					if(res.code==0){
						var k_list = res.data.default
						// list.forEach((item,index) => {

							var kc_text = []
							k_list.forEach((items)=>{
								if(items.stockStae!=1){
									var itt = item.spuList.find(val=>val.show_skuid==items.skuId)
									console.log(itt)
									if(itt!=undefined){
										kc_text.push(itt.name)
									}
								}
							})
							// kc_text = Array.from(new Set(kc_text))
							// kc_text = kc_text.toString()
							// this.$set(this.cart_list[index],'kc_text',kc_text)
							// console.log(item.kc_text)
						// })
						kc_text = kc_text.toString()
						this.$set(this.cart_list[index],'kc_text',kc_text)
						console.log(this.cart_list)
					}
					
				})
			},
		},
		computed: {}
	}
</script>

<style lang="scss" scoped>
.by_bx{
	display: inline-block;
	height:20px;
	width:38px;
	border-radius: 2px;
	background: #FB3F45;
	color:white;
	text-align: center;
	line-height: 20px;
	margin-right:6px;
	font-size:12px;
}
.jjj{
	display: inline-block;
	width:25px;
	cursor: pointer;
}
.txt_box{
	background:#F5F5F5;
	padding:16px 24px;
	margin-bottom:20px;
}
.active{
	color:#F3A251;
	border-bottom:1px solid #F3A251;
}
.wl_box:last-child{
	border:none!important;
	.yuan{
		left:-2px;
	}
}
.wl_box:nth-child(1){
	.yuan{
		height:13px!important;
		width:13px!important;
		background:#F3A251;
		top:-14px;
		left:-6px;
	}
	p{
		color:#0A1132!important;
	}
	span{
		color:#0A1132!important;
	}
}
.wl_box{
	display: flex;
	padding-left:20px;
	margin-bottom:12px;
	border-left:1px solid #CCCCCC;
	position: relative;
	.yuan{
		position: absolute;
		top:-8px;
		left:-3px;
		height:5px;
		border-radius: 50%;;
		width:5px;
		background:#CCCCCC;
	}
	span{
		width:160px;
		display: inline-block;
		margin-right:13px;
		color:#5B5D66;
		position: relative;
		top:-14px;
	}
	p{
		color:#5B5D66;
		position: relative;
		top:-14px;
		
	}
}
.ckwl{
	width:100px;
	height:34px;
	border:1px solid #E6E6E6;
	color:#0A1132;
	font-size:16px;
	cursor: pointer;
	line-height: 34px;
	text-align: center;
	display: inline-block;
	
}
.dz_top_active{
	border-color: #F3A251!important;
	background:url('../../assets/img/dz_xz.png') no-repeat right bottom ;
}
.dz_box{
	height:87px;
	cursor: pointer;
	
	border:1px solid #E6E6E6;
	padding:14px 16px;
	margin-bottom:16px;
	.dz_top{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
}
.add_rights{
	padding-left:12px;
	display: flex;
	flex-direction: column;
}
.new_adds{
	width:144px;
	height:42px;
	display: inline-block;
	text-align: center;
	line-height: 42px;
	cursor: pointer;
}
.new_add{
	width:144px;
	height:42px;
	border:1px solid rgba(232,232,232,1);
	display: inline-block;
	text-align: center;
	line-height: 42px;
	cursor: pointer;
}
.address_bottom{
	margin-top:30px;
}
	.lists{
		min-height:50px;
		// border:1px solid #E6E6E6;
		.rights{
			width:200px;
			text-align: center;
		}
		.list_bottom{
			min-height:200px;
			padding-top:20px;
			.l_box{
				display: flex;
				align-items: center;
				padding:20px;
				padding-right:0;
				border:1px dotted #CCCCCC;
			}
		}
		.list_top{
			display: flex;
			color:#909199;
			background:#F5F5F5;
			height:44px;
			line-height: 44px;
			padding-left:20px;
			
		}
		.list_bottoms{
			display: flex;
			align-items: center;
			justify-content: space-between;
			color:#909199;
			background:#F5F5F5;
			padding-left:20px;
		}
	}
	.select{
		width:145px;
		height:32px;
		margin-right:24px;
	}
	.address_text{
		// height:247px;
		width:100%;
		padding:22px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.right{
			width:421px;
			height:100%;
			border-left:1px dotted #CCCCCC;
			padding-left:32px;
			.aniu{
				display: flex;
				align-items: center;
			}
			.ljdhs{
				height:50px;
				width:186px;
				display: inline-block;
				line-height: 50px;
				margin-left:10px;
				cursor: pointer;
				text-align: center;
				color:#F3A251;
				border:1px solid;
				background:#FFFAF6;
			}
			.ljdh{
				height:50px;
				cursor: pointer;
				width:186px;
				background:#F3A251;
				display: inline-block;
				line-height: 50px;
				text-align: center;
				color:white;
			}
		}
		.left{
			height:100%;
			width:738px;
			.boxx11{
				display:flex;
				justify-content: space-between;
			
			}
			.boxx{
				display:flex;
				justify-content: space-between;
				
				align-items: center;
				margin-bottom:24px;
				.boxx1{
					display:flex;
					justify-content: space-between;
					align-items: center;
					width:47%;
					
				}
			}
		}
	}
	.address_top{
		border:1px solid #E6E6E6;
		margin-top:32px;
		height:185px;
		width:100%;
		.title{
			height:44px;
			width:100%;
			background:#F5F5F5;
			color:#909199;
			font-size:16px;
			line-height: 44px;
			padding-left:22px;
		}
	}
	.address_bigs{
		min-height:87vh;
		border-top:1px solid #E4E5ED;
	}
</style>